module.exports = __webpack_public_path__ + "static/media/Generator.3bb08c4c.png";